module.exports = __webpack_public_path__ + "media/stylesheets/images/sampleTempImage-372afd3f392356ec88bd4c9aa95a0ca8.png";